import type { PermitListResponse } from '@contracts/permitSearch/PermitListResponse';
import SearchIcon from '@mui/icons-material/Search';
import { Button } from '@src/common/components/button/Button';
import { Stack } from '@src/common/components/Stack';
import { Typography } from '@src/common/components/Typography';
import { theme } from '@src/common/styles/Theme';
import type { SearchPermitFilters } from '@src/permits/services/PermitApplicationClient';
import { Trans, useTranslation } from 'react-i18next';

interface Props {
  searchPermits: (filters: SearchPermitFilters) => void;
  filters: SearchPermitFilters;
  resetFilters: () => void;
  permits: PermitListResponse | undefined;
}

export const PermitSearchButtons = ({
  searchPermits,
  filters,
  resetFilters,
  permits,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      paddingTop={theme.spacing['8']}
    >
      <Stack direction="row" justifyItems="center">
        {permits && (
          <Typography
            style={theme.typography.label.large}
            data-testid="permitCount"
          >
            <Trans
              i18nKey="resultsCount"
              values={{
                count: permits.permits.length,
                unit: t('permits').toLowerCase(),
              }}
              components={{
                strong: <strong style={{ fontWeight: 600 }} />,
              }}
            />
          </Typography>
        )}
      </Stack>

      <Stack direction="row" justifyContent="end" gap={theme.spacing['2']}>
        <Button
          variant="contained"
          type="button"
          onClick={() => searchPermits(filters)}
        >
          <SearchIcon
            fontSize="small"
            sx={{ marginRight: theme.spacing['2'] }}
          />
          {t('search')}
        </Button>

        <Button type="button" onClick={resetFilters}>
          {t('reset')}
        </Button>
      </Stack>
    </Stack>
  );
};
